import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_UPLOAD_CLOUD: GlameraIconDefinition = {
  name: 'upload-cloud',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-upload-cloud-arrow">
      <path d="M12 13v8"></path>
      <path d="m8 17 4-4 4 4"></path>
    </g>
    <path class="glm-upload-cloud-shape" d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-upload-cloud-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './upload-cloud.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UploadCloudIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_UPLOAD_CLOUD;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
